import { render, staticRenderFns } from "./excursion-list.vue?vue&type=template&id=09ad6945&"
import script from "./excursion-list.vue?vue&type=script&lang=ts&"
export * from "./excursion-list.vue?vue&type=script&lang=ts&"
import style0 from "./excursion-list.vue?vue&type=style&index=0&id=09ad6945&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports